//Initial choice body is set to an invisibile unicode character 
//Allows web to distinguish between a choice body that has never been edited and one which has been edited but is now empty

const initialChoiceBody='\u2063'
const xLayoutVersion=process.env.REACT_APP_XLAYOUT_VERSION

export function placeholderQuestion() {
	const placeholderQuestion = {
		'choices': [{
			'body':initialChoiceBody,
			'correct': true
		},
		{
			'body':initialChoiceBody,
			'correct': false
		},
		{
			'body': initialChoiceBody,
			'correct': false
		},
		{
			'body': initialChoiceBody,
			'correct': false
		}],
		'body': 'Click here to edit question',
		'xLayout':{
			'bodyFS':64,
			'choiceFS':38,
			'bodyH':10,	 
			'version':parseInt(xLayoutVersion,10)	
		},
		'template':'standard',
		'image':''
	}
	return placeholderQuestion
}